import React from 'react';
import { withTranslation } from 'language/i18n';
import PropTypes from 'prop-types';
import Link from 'next/link';
import Image from 'next/image';

import Layout from 'components/partials/Layout';
import Breadcrumb from 'components/Breadcrumb';
import { CallTo, MailTo } from 'components/common';
import Offices from './components/Offices';
import ContactUsForm from './components/ContactUsForm';
import Banner from './components/Banner';

const ContactUs = ({ t }) => {
  const breadcrumbs = [
    {
      label: t('homepage'),
      url: '/',
    },
    {
      label: t('contactUs'),
      url: '/contact-us',
    },
  ];

  return (
    <main>
      <Banner />
      <section className="section section--transparent section--shadow pt-0">
        <div className="container">
          <div className="row mt-4 mb-4 mt-lg-3 mb-lg-3">
            <div className="col">
              <Breadcrumb links={breadcrumbs} />
            </div>
          </div>
          <div className="row">
            <div className="col-15 col-md-7">
              <div className="row mb-4">
                <div className="col">
                  <h2 className="h3">Bize Ulaşın</h2>
                  <p>
                    Sorularınız ve bilgi almak için çağrı merkezimize ulaşabilirsiniz.
                  </p>
                  <p>
                    Sıkça sorulan sorulara
                    {' '}
                    <Link href="/faq/buyers">
                      <a>buradan</a>
                    </Link>
                    {' '}
                    ulaşabilirsiniz.
                  </p>
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <div className="im-box im-box--border im-box--transparent">
                    <h3 className="h3">Müşteri Hizmetleri</h3>
                    <p className="fs-15">
                      Çağrı Merkezimize her gün 09.00 - 18.00 saatleri arasında ulaşabilirsiniz.
                    </p>
                    <a className="fs-20 d-flex align-items-center" href="tel:902322290625">
                      <i className="fa-solid fa-phone fs-30 mr-3" />
                      <CallTo className="fs-17 fw-900" tel="+90 850 885 46 25" />
                    </a>
                  </div>
                  <div className="im-box im-box--border im-box--transparent mt-3 mb-3">
                    <h3 className="h3">E-posta Adresimiz</h3>
                    <p className="fs-15">
                      Her türlü soru, görüş ve önerileriniz için bize ulaşabilirsiniz.
                    </p>
                    <a className="fs-16 d-flex align-items-center" href="mailto:info@iyimakina.com">
                      <i className="fa-solid fa-envelope fs-30 mr-3" />
                      <MailTo className="fs-15 fw-900" mail="info@iyimakina.com" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-15 col-md-8 col-lg-7 offset-lg-1">
              <ContactUsForm />
            </div>
          </div>
        </div>
      </section>
      <section className="section">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-15 col-sm-7 text-center text-sm-left">
              <h2 className="h2">Satıcı mısınız?</h2>
              <p className="fs-20">
                İkinci el iş makinanızı piyasa değerinde, hızla satalım. Formumuzu doldurun hemen iletişime geçelim
              </p>
              <Link href="/machine-sales">
                <button type="submit" className="im-button im-button--primary im-button--center mt-3 mb-4 mt-sm-5">
                  <span>{t('wantToSellMachine')}</span>
                  <div className="fa-solid fa-long-arrow-right ml-2 fs-20" />
                </button>
              </Link>
            </div>
            <div className="col-1 d-none d-sm-block text-center">
              <div className="separator separator--vertical" />
            </div>
            <div className="col-15 col-sm-7 text-center text-sm-left">
              <div>
                <div className="circle" style={{ backgroundColor: '#FFCC05' }}>
                  <Image
                    src="/image/icons/mace-black.svg"
                    width="90"
                    height="54"
                  />
                </div>
              </div>
              <h3 className="fs-20 mt-40 mb-20">Herkes En İyi Bildiği İşi Yapsın!</h3>
              <p>
                iyiMakina.com 45 yıllık sektör tecrübesiyle birlikte satış sürecini uçtan uca yönetek, profesyonel bir satış deneyimi sunar.
                Satmak istediğiniz makinaları; miminum satış garantisiyle hızlı, kolay, şeffaf ve güvenilir bir şekilde satmanıza olanak verir.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="section section--transparent section--shadow">
        <div className="container">
          <div className="row mb-20">
            <div className="col">
              <h2 className="h2 text-center">{t('ourOffices')}</h2>
            </div>
          </div>
          <div className="row">
            <div className="col-15 col-md-15">
              <Offices
                frameUrl="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3006.234792313847!2d29.025608315279595!3d41.10756302125831!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14cab5eb9ae0b3d3%3A0x180728e8ec4fc28c!2sITU%20MAGNET!5e0!3m2!1sen!2str!4v1592828338983!5m2!1sen!2str"
                titleLeft="iyiMakina.com"
                titleRight="Ar-Ge"
                address="Resitpasa Mh., Katar Cad. ITU Teknokent ARI 4, No:2/50, 34467, Sarıyer/Istanbul-Turkey"
                tel="+90 (216) 212 28 32"
                fax="+90 (216) 212 28 32"
                mail="info@iyimakina.com"
              />
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

ContactUs.propTypes = {
  t: PropTypes.func,
};

ContactUs.Layout = Layout;

export default withTranslation('common')(ContactUs);
